import React from 'react';
import { Select } from 'antd';
import { overallStatusOptions } from '../../config/filterOptions';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../utils/languageUtils';

interface MultiParcelStatusSelectFilterProps {
  label: string;
  value?: string[];
  onChange: (value: string[] | undefined) => void;
  spanClassName?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const MultiParcelStatusSelectFilter: React.FC<MultiParcelStatusSelectFilterProps> = ({
  label,
  value,
  onChange,
  spanClassName,
  placeholder = 'All',
  className,
  disabled = false
}) => {
  const options = React.useMemo(() => {
    return overallStatusOptions.map(option => ({
      label: option.label,
      value: option.value.toString(),
      searchText: option.label
    }));
  }, []);

  // 使用统一的样式 Hook，根据语言自动返回合适的样式类名
  const containerClassName = useFilterContainerClassName(className);
  const labelClassName = useFilterLabelClassName(spanClassName);
  const inputContainerClassName = useFilterInputContainerClassName();

  return (
    <div className={containerClassName}>
      <span className={labelClassName}>{label}</span>
      <div className={inputContainerClassName}>
        <Select
          mode="multiple"
          showSearch
          allowClear
          placeholder={placeholder}
          value={value}
          onChange={(val) => onChange(val && val.length > 0 ? val : undefined)}
          options={options}
          disabled={disabled}
          filterOption={(input, option) => {
            const searchText = (option as any)?.searchText || '';
            return searchText.toLowerCase().includes(input.toLowerCase());
          }}
          className="w-full"
          size="middle"
          maxTagCount="responsive"
          maxTagTextLength={10}
          tagRender={(props) => {
            const { label, closable, onClose } = props;
            return (
              <span className="ant-select-selection-item inline-flex items-center bg-gray-100 text-gray-800 rounded px-2 py-1 text-xs mr-1 mb-1">
                <span className="ant-select-selection-item-content truncate max-w-[120px]">{label}</span>
                {closable && (
                  <span 
                    className="ant-select-selection-item-remove ml-1 cursor-pointer hover:text-red-500" 
                    onClick={onClose}
                  >
                    ×
                  </span>
                )}
              </span>
            );
          }}
        />
      </div>
    </div>
  );
};

export default MultiParcelStatusSelectFilter;
